/**
 * Entrypoint — production-only stack.
 *
 * Изолированный entry для production.<домен>. Содержит:
 *   - ProductionShell (свой layout с одной вкладкой)
 *   - ProductionPage + ProductionDetailPage
 *   - LoginPage / ResetPasswordPage / ProfilePage (общие)
 *   - AuthContext (общий — backend и кука те же)
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { AuthProvider } from "@/auth/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PeriodProvider } from "@/state/period";
import { buildProductionRouter } from "@/router.production";
import { bootstrapTheme } from "@/lib/useTheme";
import { setBrandFavicon } from "@/lib/setBrandFavicon";
import "@/styles/global.css";
import "@/styles/production-tg.css";

bootstrapTheme();
setBrandFavicon("production");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const router = buildProductionRouter(queryClient);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No #root element");

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PeriodProvider>
            <RouterProvider router={router} />
          </PeriodProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
